'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

import LuneButton from '@/components/LuneButton'
import TwoColumnsWithBackgroundImage from '@/components/TwoColumnsWithBackgroundImage'

const CustomerStoryWithTiles: FC<{
    logo?: ReactNode
    text: ReactNode
    light?: boolean
    button?: {
        label: string
        href: string
        target?: string
    }
    backgroundImage?: string
    mobileBackgroundImage?: string
    rightSide?: ReactNode
    textVariant?: 'body' | 'heading'
    label?: string
}> = ({
    logo,
    text,
    light,
    button,
    mobileBackgroundImage,
    backgroundImage,
    rightSide,
    textVariant = 'body',
    label = 'CUSTOMER STORY',
}) => {
    const { mdScreen, smScreen } = useDevice()
    const { palette } = LuneTheme

    return (
        <TwoColumnsWithBackgroundImage
            backgroundImage={backgroundImage}
            mobileBackgroundImage={mobileBackgroundImage}
            leftSide={
                <Box
                    sx={{
                        gap: mdScreen ? 3 : 4,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        height: 'max-content',
                        maxWidth: smScreen ? 'auto' : '435px',
                    }}
                >
                    <Text variant={'button'}>{label}</Text>
                    {logo}
                    <Text
                        sx={{ color: light ? `${palette.White}` : `${palette.Grey900}` }}
                        variant={
                            textVariant === 'heading'
                                ? mdScreen
                                    ? 'h5'
                                    : 'h4'
                                : mdScreen
                                  ? 'body2'
                                  : 'body1'
                        }
                        {...(textVariant === 'heading' ? { component: 'div' as const } : {})}
                    >
                        {text}
                    </Text>
                    {button && (
                        <LuneButton
                            label={button.label}
                            href={button.href}
                            target={button.target}
                        />
                    )}
                </Box>
            }
            rightSide={rightSide}
            reversedOnMobile={false}
            sx={
                backgroundImage === undefined && mobileBackgroundImage === undefined
                    ? { backgroundImage: 'none' }
                    : undefined
            }
        />
    )
}

export default CustomerStoryWithTiles
